<template>
  <a-modal
    :title="`设置[${this.category.name}]类的快捷方式`"
    :visible="true"
    okText="确认"
    cancelText="取消"
    width="590px"
    @cancel="
      () => {
        $emit('ok');
      }
    "
    @ok="
      () => {
        $emit('ok');
      }
    "
  >
    <a-transfer
      :data-source="eventList"
      show-search
      :locale="{
        itemUnit: '项',
        itemsUnit: '项',
        notFoundContent: '事件为空',
        searchPlaceholder: '搜索事件名、描述和缩写'
      }"
      :list-style="{
        width: '250px',
        height: '300px'
      }"
      :filter-option="filterOption"
      :target-keys="targetKeys"
      :render="item => `${item.icon} ${item.title} - [${item.abbr}]`"
      @change="handleChange"
      @search="handleSearch"
    ></a-transfer>
  </a-modal>
</template>

<script>
import { mapActions } from "vuex";
export default {
  props: ["event", "category"],
  data() {
    return {
      targetKeys: [],
      eventList: []
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      //初始化结果
      const targetKeys = [];
      const eventList = [];

      //获取分类对象和事件列表
      const category = this.$store.getters.categorys[this.category.id];
      const events = this.$store.getters.events;

      for (const key in events) {
        const { id, abbr, name, description, icon } = events[key];
        const data = {
          key: id,
          abbr: abbr,
          title: name,
          icon: icon ? icon : "",
          description
        };
        //判断分类中是否有该事件的快捷方式
        if (category.shortcut.includes(key)) {
          targetKeys.push(key);
        }

        eventList.push(data);
      }

      this.eventList = eventList;
      this.targetKeys = targetKeys;
    },
    filterOption(inputValue, item) {
      //过滤函数过滤数据
      const serach = inputValue.toUpperCase();
      return (
        item.abbr.toUpperCase().match(serach) ||
        item.title.toUpperCase().match(serach) ||
        item.description.toUpperCase().match(serach)
      );
    },
    // handleChange(targetKeys, direction, moveKeys) {
    handleChange(targetKeys) {
      this.setShortcut({ id: this.category.id, shortcut: targetKeys });
      this.targetKeys = targetKeys;
    },
    // handleSearch(dir, value)
    handleSearch() {
      // console.log("搜索:", dir, value);
    },
    ...mapActions(["setShortcut"])
  }
};
</script>
